/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import VueI18n from "vue-i18n";
import i18nData from "./i18nData";
import translations from "./en/translations.json";
// Domain-specific translation namespaces — added incrementally so the legacy
// monolithic translations.json doesn't have to grow further. Each module owns
// its own JSON; merge into the locale tree on boot.
import dealEn from "./en/deal.json";
import dealVi from "./vi/deal.json";

Vue.use(VueI18n);
i18nData.en = { ...i18nData.en, ...translations, ...dealEn };
i18nData.vi = { ...(i18nData.vi || {}), ...dealVi };

export default new VueI18n({
  locale: "en", // set default locale
  fallbackLocale: "en",
  messages: i18nData,
  silentTranslationWarn: true,
});
